import { useQuery } from "@tanstack/react-query";
import { getWorkerUnassignedTime } from "../api/workers";

/** Temps sans projet d'un worker sur une période. La clé commence par celle de
 * la timeline : un pointage, une édition ou une réimputation la relit. */
export function unassignedTimeQuery(
  workerUrl: string,
  from: string,
  to: string,
  enabled = true,
) {
  return {
    queryKey: [
      "tawa",
      "worker",
      "timeline",
      "unassigned-time",
      workerUrl,
      from,
      to,
    ],
    queryFn: () => getWorkerUnassignedTime({ worker_url: workerUrl, from, to }),
    enabled: enabled && !!workerUrl && !!from && !!to,
    staleTime: 30_000,
  };
}

export function useUnassignedTime(
  workerUrl: string,
  from: string,
  to: string,
  options?: { enabled?: boolean },
) {
  return useQuery(
    unassignedTimeQuery(workerUrl, from, to, options?.enabled ?? true),
  );
}
